import React, { useEffect, useState } from 'react';
import { Clock, ArrowRight } from 'lucide-react';
import { useCurrency } from '../../hooks/useCurrency';
const COUNTDOWN_KEY = 'countdown-timer';
const DEFAULT_TIME = 5 * 60 * 60; // 5 hours in seconds
export function TopBanner() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem(COUNTDOWN_KEY);
    if (saved) {
      const parsed = parseInt(saved, 10);
      if (parsed > 0 && parsed <= DEFAULT_TIME) {
        return parsed;
      }
    }
    return DEFAULT_TIME;
  });
  const checkoutUrl = 'https://buy.stripe.com/5kQaEX0uN7FEdBo3ojefC0a';
  const {
    formatPrice
  } = useCurrency();
  useEffect(() => {
    // Save initial time if not already saved
    if (!localStorage.getItem(COUNTDOWN_KEY)) {
      localStorage.setItem(COUNTDOWN_KEY, DEFAULT_TIME.toString());
    }
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const newTime = prev > 0 ? prev - 1 : 0;
        if (newTime % 5 === 0) {
          localStorage.setItem(COUNTDOWN_KEY, newTime.toString());
        }
        return newTime;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return {
      h,
      m,
      s
    };
  };
  const {
    h,
    m,
    s
  } = formatTime(timeLeft);
  return <div className="bg-[#3A3A3A] text-white py-3 px-4 relative z-[60] border-b border-[#C9A86A]/20 shadow-md" data-id="element-340">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center sm:text-left" data-id="element-341">
        <div className="flex items-center gap-2 text-[#C9A86A]" data-id="element-342">
          <Clock className="w-4 h-4 animate-pulse" data-id="element-343" />
          <span className="text-xs font-bold tracking-widest uppercase" data-id="element-344">
            Oferta Flash
          </span>
        </div>

        <div className="flex items-center gap-2 font-mono text-sm tracking-widest text-[#FAF7F5]" data-id="element-345">
          <span className="bg-white/10 px-2 py-1 rounded min-w-[2.5em] text-center" data-id="element-346">
            {h.toString().padStart(2, '0')}h
          </span>
          <span className="text-[#C9A86A]" data-id="element-347">:</span>
          <span className="bg-white/10 px-2 py-1 rounded min-w-[2.5em] text-center" data-id="element-348">
            {m.toString().padStart(2, '0')}m
          </span>
          <span className="text-[#C9A86A]" data-id="element-349">:</span>
          <span className="bg-white/10 px-2 py-1 rounded min-w-[2.5em] text-center text-[#C9A86A]" data-id="element-350">
            {s.toString().padStart(2, '0')}s
          </span>
        </div>

        <div className="hidden sm:block w-px h-4 bg-white/20" data-id="element-351" />

        <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-3 text-xs sm:text-sm hover:text-[#C9A86A] transition-colors bg-white/5 px-4 py-1.5 rounded-full hover:bg-white/10" data-id="element-352">
          {/* Promo especial price */}
          <span className="text-gray-300" data-id="element-353">Promo especial:</span>
          <span className="font-bold text-white text-base" data-id="element-354">
            {formatPrice(16.99)}
          </span>
          <span className="bg-gradient-to-r from-[#C9A86A] to-[#D4A5A5] text-white text-[10px] font-bold px-2 py-0.5 rounded-full ml-1 shadow-sm" data-id="element-355">
            -50%
          </span>
          <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform text-[#C9A86A]" data-id="element-356" />
        </a>
      </div>
    </div>;
}